import React from 'react';
import MockupShell from './MockupShell';

const MODULES = [
  { n: 1, title: 'Builder Mindset Foundations',          mins: 8,  state: 'done',     desc: 'Why structure beats hype. Watch first.' },
  { n: 2, title: 'How the BBC Quick List funnel works',  mins: 11, state: 'done',     desc: 'Four-touch system, Personal/Network/Global queues.' },
  { n: 3, title: 'Setting up your TRON TRC-20 wallet',   mins: 9,  state: 'done',     desc: 'Non-custodial wallet basics and security.' },
  { n: 4, title: 'Sharing your referral link cleanly',   mins: 7,  state: 'inprogress', desc: 'Scripts, examples, and DM templates.' },
  { n: 5, title: 'Pay-It-Forward mechanics in plain English', mins: 10, state: 'locked', desc: 'Walkthrough of the 5.95 USDT cycle.' },
  { n: 6, title: 'Lead Capture pages that actually convert', mins: 14, state: 'locked', desc: 'Anatomy of a high-converting builder page.' },
  { n: 7, title: 'Using rotators for split-testing',     mins: 6,  state: 'locked',   desc: 'A/B test two paths from one short link.' },
  { n: 8, title: 'Phase 2 unlock walk-through',           mins: 13, state: 'locked',   desc: '12×3 matrix entry, what unlocks, what doesn&apos;t.' },
];

function ModuleCard({ m, idx }) {
  const isDone = m.state === 'done';
  const isProg = m.state === 'inprogress';
  const isLock = m.state === 'locked';

  return (
    <div className="mk-card" data-testid={`training-module-${m.n}`} style={{ display: 'flex', flexDirection: 'column', gap: 10, opacity: isLock ? 0.7 : 1 }}>
      <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between', gap: 10 }}>
        <span style={{ fontSize: 11, color: 'var(--mk-muted)', letterSpacing: '0.06em', textTransform: 'uppercase' }}>Module {m.n} · {m.mins} min</span>
        {isDone && <span className="mk-badge mk-badge--success">Completed</span>}
        {isProg && <span className="mk-badge mk-badge--amber">In progress</span>}
        {isLock && <span className="mk-badge mk-badge--muted">Locked</span>}
      </div>
      <div
        aria-hidden
        style={{
          height: 100,
          borderRadius: 10,
          background: isLock
            ? 'repeating-linear-gradient(135deg, #1f2937 0 14px, #171f2b 14px 28px)'
            : 'linear-gradient(135deg, rgba(245,197,66,0.18), rgba(245,158,11,0.08))',
          border: '1px solid var(--mk-border)',
          display: 'grid',
          placeItems: 'center',
        }}
      >
        <span style={{ fontSize: 38 }}>{isLock ? '🔒' : '▶'}</span>
      </div>
      <h3 style={{ margin: 0, fontSize: 15 }}>{m.title}</h3>
      <p style={{ margin: 0, fontSize: 12, color: 'var(--mk-muted)', lineHeight: 1.5 }}>{m.desc}</p>
      {isDone   && <button className="mk-btn mk-btn--ghost" style={{ alignSelf: 'flex-start' }}>Rewatch</button>}
      {isProg   && <button className="mk-btn" style={{ alignSelf: 'flex-start' }} data-testid={`resume-${m.n}`}>Resume</button>}
      {isLock   && <button className="mk-btn mk-btn--disabled" disabled style={{ alignSelf: 'flex-start' }}>Locked · finish prior</button>}
    </div>
  );
}

export default function TrainingVault() {
  const done = MODULES.filter((m) => m.state === 'done').length;
  const total = MODULES.length;
  const pct = Math.round((done / total) * 100);

  return (
    <MockupShell
      title="Training Vault"
      subtitle="Founder-led training. Watch in order. Unlocks progress through your tier and PIF queues."
      dataTestId="mockup-training-vault"
    >
      <div className="mk-card" style={{ marginBottom: 18 }}>
        <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', flexWrap: 'wrap', gap: 10, marginBottom: 10 }}>
          <div>
            <h3 style={{ margin: 0 }}>Your training progress</h3>
            <p style={{ margin: '4px 0 0', fontSize: 12, color: 'var(--mk-muted)' }}>{done} of {total} modules · {pct}% complete · ~52 minutes remaining</p>
          </div>
          <button className="mk-btn" data-testid="continue-training-btn">Continue Module 4</button>
        </div>
        <div className="mk-progress"><div className="mk-progress-fill" style={{ width: `${pct}%` }} /></div>
      </div>

      <div className="mk-grid mk-grid--3">
        {MODULES.map((m, idx) => <ModuleCard key={m.n} m={m} idx={idx} />)}
      </div>
    </MockupShell>
  );
}
